// File: components/inspections/InspectionEditPage.jsx
import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import EditingSection from "./EditingSection";
import { getInspectionById } from "../../../services/api/qa/inspectionService";
import { Toaster } from "react-hot-toast";

function InspectionEditPage() {
  const { id } = useParams(); // inspection ID from route
  const navigate = useNavigate();

  const [inspectionData, setInspectionData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const getInspection = async () => {
      setLoading(true);
      try {
        const response = await getInspectionById(id);
        if (response.data) {
          setInspectionData(response.data);
        } else {
          setError("Inspection not found.");
        }
      } catch (err) {
        console.error(err);
        setError("Failed to fetch inspection data.");
      } finally {
        setLoading(false);
      }
    };

    getInspection();
  }, [id]);

  const handleUpdate = (updatedInspection) => {
    setInspectionData(updatedInspection);
  };

  if (loading) return <p className="p-4">Loading inspection details...</p>;
  if (error) return <p className="p-4 text-red-500">{error}</p>;
  if (!inspectionData) return null;

  return (
    <div className="max-w-3xl mx-auto p-4">
      <Toaster position="top-right" reverseOrder={false} />

      <div className="mb-4 flex justify-between items-center">
        <h1 className="text-2xl font-bold">Inspection: {inspectionData.id}</h1>
        <button
          onClick={() => navigate(-1)}
          className="bg-gray-200 px-3 py-1 rounded hover:bg-gray-300"
        >
          Back
        </button>
      </div>

      <EditingSection
        inspectionData={inspectionData}
        onUpdate={handleUpdate}
      />
    </div>
  );
}

export default InspectionEditPage;